import { NavLink, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '@iconify/react';
import logoZona from '../../assets/images/icons/logo.svg';
import MiamiClock from '../MiamiClock/MiamiClock';
import { colors } from '../AffiliateUI/AffiliateUI';

// Self-contained chrome for the affiliate-admin section, ported from the
// standalone affiliates.zona.miami portal's Layout.tsx: a slim top bar +
// bottom tab nav instead of the main admin's left sidebar. Keeps the
// affiliate section's own compact UI rather than flattening it into 5
// separate top-level sidebar items.
const navItems = [
  { to: '/affiliates', icon: 'solar:users-group-rounded-outline', label: 'Affiliates' },
  { to: '/affiliate-analytics', icon: 'solar:chart-2-outline', label: 'Analytics' },
  { to: '/affiliate-waitlist', icon: 'solar:user-plus-outline', label: 'Waitlist' },
  { to: '/affiliate-payouts', icon: 'solar:wallet-money-outline', label: 'Payouts' },
  { to: '/affiliate-demos', icon: 'solar:eye-outline', label: 'Demos' },
];

const AffiliateLayout = ({ children }) => {
  const navigate = useNavigate();

  return (
    <Shell>
      <TopBar>
        <TopLeft>
          <BackBtn onClick={() => navigate('/')} title="Back to admin">
            <Icon icon="solar:alt-arrow-left-outline" width={16} />
          </BackBtn>
          <Logo src={logoZona} alt="ZONA" />
          <Divider />
          <PortalLabel>AFFILIATE ADMIN</PortalLabel>
        </TopLeft>
        <TopRight>
          <MiamiClock />
        </TopRight>
      </TopBar>

      <BottomNav>
        {navItems.map((item) => (
          <BottomNavItem key={item.to} to={item.to}>
            <Icon icon={item.icon} width={20} />
            <BottomNavLabel>{item.label}</BottomNavLabel>
          </BottomNavItem>
        ))}
      </BottomNav>

      <PageArea>{children}</PageArea>
    </Shell>
  );
};

export default AffiliateLayout;

const Shell = styled.div`min-height: 100vh; background: ${colors.bg};`;

const TopBar = styled.header`
  position: fixed;
  top: 0; left: 0; right: 0;
  height: 56px;
  padding: 0 16px;
  background: rgba(5,5,5,0.85);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(255,255,255,0.04);
  display: flex; align-items: center; justify-content: space-between;
  z-index: 200;
`;

const TopLeft = styled.div`display: flex; align-items: center; gap: 10px; min-width: 0; height: 100%;`;
const BackBtn = styled.button`
  background: none; border: none; color: rgba(255,255,255,0.35);
  padding: 4px; display: flex; align-items: center; justify-content: center; cursor: pointer;
  &:hover { color: #fff; }
`;
const Logo = styled.img`height: 16px; display: block; flex-shrink: 0;`;
const Divider = styled.div`
  width: 1px; height: 14px; background: rgba(255,255,255,0.08); flex-shrink: 0;
  @media (max-width: 420px) { display: none; }
`;
const PortalLabel = styled.span`
  font-size: 9px; font-weight: 700; letter-spacing: 2px;
  color: rgba(255,255,255,0.2); line-height: 1;
  @media (max-width: 420px) { display: none; }
`;
const TopRight = styled.div`display: flex; align-items: center; gap: 8px; flex-shrink: 0;`;

const BottomNav = styled.nav`
  position: fixed;
  bottom: 0; left: 0; right: 0;
  height: 60px;
  background: rgba(5,5,5,0.92);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-top: 1px solid rgba(255,255,255,0.04);
  display: flex; align-items: center; justify-content: space-around;
  z-index: 200;
`;
const BottomNavItem = styled(NavLink)`
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 3px; padding: 8px 10px; color: rgba(255,255,255,0.28);
  text-decoration: none; transition: color 0.15s; min-width: 56px; min-height: 44px;
  &:hover { color: rgba(255,255,255,0.5); }
  &.active { color: ${colors.primary}; }
`;
const BottomNavLabel = styled.span`font-size: 10px; font-weight: 500; letter-spacing: 0.2px;`;

const PageArea = styled.main`
  padding-top: 72px;
  padding-right: 16px;
  padding-bottom: 80px;
  padding-left: 16px;
  max-width: 1100px; margin: 0 auto; width: 100%;
  @media (min-width: 640px) { padding-right: 24px; padding-left: 24px; }
`;
